// Hana — the story: which form the light takes when, where the lens is, what the sky does.
// Times are seconds into the song (measured from the master; see README).
(function () {
  const H = window.HANA;
  const { lerp, smooth, mixArr } = H;

  // form ids, shared with the particle shader (gfx.js)
  const F = H.FORM = {
    SEED: 0, SEA: 1, DAWN: 2, WORLD: 3, FLOWERS: 4, GALAXY: 5, INK: 6, BYE: 7, RAIN: 8, EYE: 9,
    OLIVE: 10, SOLO: 11, FLEUR: 12, CYCLE: 13, LETGO: 15, DESTINY: 16, INK2: 17, RAINUP: 18, ONE: 19,
    TRIP_FLOWERS: 20, TRIP_SEA: 21, TRIP_DESERT: 22, TRIP_STARS: 23, TRIP_NEBULA: 24
  };

  // at: when the light starts becoming this form; d: how long the change takes
  H.SCENES = [
    { at: 0, d: 0.01, form: F.SEED },      // short intro: a seed of light
    { at: 15.0, d: 2.6, form: F.SEA },     // sunset, sparkles on the shore
    { at: 31.8, d: 2.6, form: F.DAWN },    // sunrise, white threads of dawn
    { at: 48.4, d: 2.4, form: F.WORLD },   // a perfect world: earth and moon; the moon (the knight) takes a barrage of meteors, then loses its orbit and shatters the earth
    { at: 64.3, d: 1.8, form: F.FLOWERS }, // a thousand flowers, a million reasons
    { at: 72.5, d: 1.8, form: F.GALAXY },  // a billion memories: neurons and synapses
    { at: 76.8, d: 1.3, form: F.INK },     // ink made of oceans
    { at: 81.0, d: 1.6, form: F.BYE },     // a million goodbyes: stars going supernova
    { at: 85.4, d: 1.5, form: F.RAIN },    // a billion sorries
    { at: 88.6, d: 1.3, form: F.EYE },     // a forever in a blink: the Helix, an eye in the sky
    { at: 92.8, d: 1.2, form: F.OLIVE },   // a pen made of olives
    { at: 97.0, d: 2.2, form: F.TRIP_FLOWERS },  // guitar and violin: two lights travel over flower fields,
    { at: 105.8, d: 2.0, form: F.TRIP_SEA },     // oceans,
    { at: 113.9, d: 2.0, form: F.TRIP_DESERT },  // deserts,
    { at: 122.1, d: 2.0, form: F.TRIP_STARS },   // starfields,
    { at: 130.2, d: 2.0, form: F.TRIP_NEBULA },  // nebulae,
    { at: 138.4, d: 2.4, form: F.SOLO },         // then dance above the ocean and climb into the bridge
    { at: 153.0, d: 2.6, form: F.FLEUR },  // an infinite spiral of lilies
    { at: 163.5, d: 1.6, form: F.CYCLE },  // sunsets and sunrises, faster and faster through the drop
    { at: 176.4, d: 1.6, form: F.LETGO },  // i don't need a thousand flowers
    { at: 183.9, d: 1.5, form: F.DESTINY },// a billion destinies: strings, a tesseract, folded dimensions
    { at: 188.1, d: 1.3, form: F.INK2 },   // ink made of oceans, flowing home
    { at: 191.8, d: 1.6, form: F.RAINUP }, // no goodbyes, no sorries
    { at: 199.4, d: 2.4, form: F.ONE },    // one chance: one flower
    { at: 238.4, d: 6.0, form: F.SEED }    // back to a seed
  ];

  // the scene state at song time t: forms A -> B with mix k
  H.sceneAt = function (t) {
    const S = H.SCENES;
    let i = 0;
    while (i + 1 < S.length && S[i + 1].at <= t) i++;
    const s = S[i], prev = S[Math.max(0, i - 1)];
    const k = i === 0 ? 1 : H.clamp((t - s.at) / s.d, 0, 1);
    return k >= 1 ? { A: s.form, B: s.form, k: 1 } : { A: prev.form, B: s.form, k };
  };

  // seed radius / tilt / glow for the seed form
  H.seedAt = function (t, mode) {
    if (mode === 'title') return [1.15, 0, 1];
    if (t < 30) {
      const R = 1.15 + 1.55 * smooth(0.5, 15.5, t);
      return [R, 1.25 * smooth(8, 16.5, t), 1];
    }
    // the end: the flower folds back into one point of light
    const R = 2.1 * (1 - smooth(240, 252.2, t)) + 0.004;
    return [R, 0.25, Math.min(1, R * 1.6 + 0.02) * (1 - smooth(252.2, 254, t) * 0.85)];
  };

  // ---- camera: position, target, field of view
  const S2 = Math.sin;
  const CAM = {};
  CAM[F.SEED] = t => ({ p: [0.25 * S2(t * 0.11), 0.12 * S2(t * 0.07), 7.2 - 0.6 * smooth(0, 16, t)], q: [0, 0, 0], fov: 44 });
  CAM[F.SEA] = t => ({ p: [0.5 * S2(t * 0.05), 0.05, 9], q: [0.2 * S2(t * 0.04), -2.1, -20], fov: 46 });
  CAM[F.DAWN] = t => ({ p: [0.4 * S2(t * 0.05), 0.15, 9], q: [-0.6, -1.4, -20], fov: 48 });
  CAM[F.WORLD] = t => { const s = smooth(56.6, 59, t) * (1 - smooth(61.5, 63, t)), b = smooth(62.6, 63.9, t); return { p: [1.2 * S2(t * 0.1) + 1.4 * s, lerp(1.25, 1.6, s), lerp(7.0, 7.6, s) + 3.5 * b], q: [1.5 * s, 0.3, 0], fov: 44 }; };   // in close for the barrage; back for the crash
  CAM[F.FLOWERS] = t => ({ p: [0.4 * S2(t * 0.08), -0.25 + 0.04 * (t - 64), 9 - 0.09 * (t - 64)], q: [0, -1.55, -20], fov: 48 });
  CAM[F.GALAXY] = t => { const a = (t - 72) * 0.04; return { p: [9 * S2(a), 1.6, 9 * Math.cos(a) - 3], q: [0, 0.5, -4], fov: 46 }; };
  CAM[F.INK] = t => ({ p: [0.3 * S2(t * 0.2), 0.2, 8.6], q: [0, 0.1, 0], fov: 44 });
  CAM[F.BYE] = t => ({ p: [0.3, 0.25, 8.6 + 1.1 * smooth(81, 85.4, t)], q: [-0.4, 0.4, -2], fov: 52 });
  CAM[F.RAIN] = t => ({ p: [0, 0.55, 8.6], q: [0, -0.7, -5], fov: 46 });
  CAM[F.EYE] = t => ({ p: [0.15 * S2(t * 0.2), 0.05, 9.4 - 0.15 * (t - 88.6)], q: [0, 0.2, 0], fov: 50 });
  CAM[F.OLIVE] = t => ({ p: [0.3 * S2(t * 0.15), 0.1, 8.2], q: [0, 0, 0], fov: 44 });
  CAM[F.SOLO] = t => {
    const a = (soloPh(t) - soloPh(138.4)) * 0.06, up = smooth(146, 153.5, t);
    const y = H.clamp((t - 146) / 7.4, 0, 1), rise = 2 * y * y * y;  // follows the spiral as it climbs faster
    const R = 8.2 - 1.2 * smooth(105, 125, t); return { p: [R * S2(a), 1.2 * S2(t * 0.05) + up * 1.5 + rise, R * Math.cos(a)], q: [0, up * 1.6 + rise, 0], fov: 46 };
  };
  // the journey: following the two lights from behind as the land slides past beneath
  const TRIP = t => ({ p: [0.8 * S2(t * 0.09), 1.5 + 0.3 * S2(t * 0.07), 9.4], q: [0.3 * S2(t * 0.05), -0.5, -6], fov: 52 });
  CAM[F.TRIP_FLOWERS] = TRIP; CAM[F.TRIP_SEA] = TRIP; CAM[F.TRIP_DESERT] = TRIP; CAM[F.TRIP_STARS] = TRIP; CAM[F.TRIP_NEBULA] = TRIP;
  CAM[F.FLEUR] = t => ({ p: [0.2 * S2(t * 0.1), 0.15 * S2(t * 0.13), 9.2], q: [0, 0, 0], fov: 46 });
  CAM[F.CYCLE] = t => ({ p: [0, 0.05, 9 - 0.9 * Math.pow(cycX(t), 1.5)], q: [0, -0.9, -20], fov: 50 });
  CAM[F.LETGO] = t => { const u = smooth(178, 184, t); return { p: [0.4 * S2(t * 0.08), -0.15 + 0.6 * u, 8.6], q: [0, lerp(-1.5, 1.5, u), -20], fov: 48 }; };
  CAM[F.DESTINY] = t => ({ p: [0.3 * S2(t * 0.1), 0.2, 9.2], q: [0, 0.2, 0], fov: 46 });
  CAM[F.INK2] = t => ({ p: [0, 0.2, 9], q: [0, 0, 0], fov: 46 });
  CAM[F.RAINUP] = t => ({ p: [0, 0.4, 8.6], q: [0, lerp(-0.6, 0.6, smooth(193, 199, t)), -5], fov: 46 });
  CAM[F.ONE] = t => {
    const a = (t - 199) * 0.035, c = smooth(199.5, 206, t);
    // as she is traced out of the flower, the camera draws back until the whole of her is seen, the plumeria in her hair
    const g = smooth(209.5, 228, t), G = [-4.6, -1.9];
    return { p: [lerp(2.0 * S2(a), G[0], g), lerp(lerp(0.4, 1.4, c), G[1], g), lerp(lerp(8.6, 6.4, c), 16.5, g)], q: [lerp(0, G[0], g), lerp(0.15, G[1], g), 0], fov: 44 };
  };

  // the solo's dance time (same as the shader): it quickens toward the bridge
  function soloPh(t) { const x = H.clamp((t - 97.6) / 56, 0, 1); return t * 0.7 + 28 * x * x * x + 1.5 * Math.max(t - 153.6, 0); }

  // sunsets and sunrises (same as the shader): they keep quickening until the chorus, nine times as fast
  function cycX(t) { return H.clamp((t - 165) / 11.4, 0, 1); }
  function cycPh(t) { const x = cycX(t); return (t - 163.5) + 8 * (11.4 * x * x * x / 3 + Math.max(t - 176.4, 0)); }
  function cycSun(t) { const v = cycPh(t) * 0.2 + 0.5; return v - Math.floor(v); }

  H.camAt = function (form, t) { return CAM[form](t); };

  // ---- sky: zenith, horizon, sun direction, sun colour, sun strength, stars
  const SKY = {};
  const night = { z: [0.008, 0.009, 0.025], h: [0.05, 0.035, 0.085], s: [0, 0.05, -1], c: [1, 0.7, 0.5], i: 0, st: 0.75 };
  SKY[F.SEED] = t => t > 200 ? { ...night, h: [0.07, 0.045, 0.1], st: 0.9 } : night;
  SKY[F.SEA] = () => ({ z: [0.035, 0.03, 0.1], h: [0.95, 0.4, 0.3], s: [0, 0.018, -1], c: [1, 0.55, 0.32], i: 1.2, st: 0.12 });
  SKY[F.DAWN] = t => ({ z: [0.1, 0.14, 0.3], h: [0.95, 0.84, 0.72], s: [-0.045, 0.02 + 0.002 * (t - 32), -1], c: [1, 0.86, 0.66], i: 1.2, st: 0 });
  SKY[F.WORLD] = t => ({ ...night, z: [0.006, 0.008, 0.022], h: [0.03, 0.035, 0.07], st: 1 });   // space, around the earth
  SKY[F.FLOWERS] = () => ({ z: [0.09, 0.11, 0.28], h: [1.0, 0.6, 0.38], s: [0.22, 0.03, -1], c: [1, 0.66, 0.4], i: 1.1, st: 0 });
  SKY[F.GALAXY] = () => ({ ...night, st: 1 });
  SKY[F.INK] = () => ({ z: [0.004, 0.015, 0.04], h: [0.02, 0.07, 0.15], s: [0, 0.1, -1], c: [0.5, 0.7, 1], i: 0.2, st: 0.35 });
  SKY[F.BYE] = t => {
    // every blast of the chain lights the whole sky a little (times match the shader's snT)
    let f = 0;
    for (let k = 0; k < 13; k++) { const a = t - (81.6 + 0.58 * (1 - Math.pow(0.85, k)) / 0.15); if (a > 0) f += Math.exp(-a * 3.5) * (1 + k / 13); }
    f = Math.min(f, 2.2);
    return { ...night, z: mixArr([0.01, 0.008, 0.03], [0.06, 0.04, 0.1], f * 0.45), h: mixArr([0.07, 0.035, 0.09], [0.3, 0.14, 0.3], f * 0.45), st: 0.9 };
  };
  SKY[F.RAIN] = () => ({ z: [0.025, 0.032, 0.06], h: [0.12, 0.14, 0.21], s: [0, 0.2, -1], c: [0.7, 0.8, 1], i: 0.1, st: 0 });
  SKY[F.EYE] = () => ({ ...night, z: [0.012, 0.006, 0.012], h: [0.03, 0.012, 0.02], st: 0.8 });
  SKY[F.OLIVE] = () => ({ z: [0.035, 0.04, 0.06], h: [0.26, 0.25, 0.16], s: [0.3, 0.06, -1], c: [1, 0.85, 0.55], i: 0.35, st: 0.1 });
  SKY[F.SOLO] = t => ({ ...night, h: [0.06, 0.035, 0.12], st: 0.85, aur: smooth(100, 112, t) * (1 - smooth(152, 155, t)) });
  SKY[F.TRIP_FLOWERS] = () => ({ z: [0.06, 0.06, 0.18], h: [0.85, 0.5, 0.36], s: [0.15, 0.02, -1], c: [1, 0.62, 0.38], i: 1.0, st: 0.05 });
  SKY[F.TRIP_SEA] = () => ({ z: [0.012, 0.02, 0.06], h: [0.08, 0.12, 0.22], s: [0, 0.06, -1], c: [0.75, 0.82, 1], i: 0.6, st: 0.6 });
  SKY[F.TRIP_DESERT] = () => ({ z: [0.04, 0.035, 0.11], h: [0.7, 0.36, 0.28], s: [-0.25, 0.015, -1], c: [1, 0.55, 0.32], i: 1.1, st: 0.25 });
  SKY[F.TRIP_STARS] = () => ({ ...night, z: [0.004, 0.004, 0.012], h: [0.01, 0.01, 0.03], st: 1 });
  SKY[F.TRIP_NEBULA] = () => ({ ...night, z: [0.012, 0.006, 0.025], h: [0.04, 0.02, 0.06], st: 0.9 });
  SKY[F.FLEUR] = () => ({ z: [0.012, 0.01, 0.04], h: [0.11, 0.07, 0.2], s: [0, 0.05, -1], c: [1, 0.7, 0.5], i: 0, st: 0.6 });
  SKY[F.CYCLE] = t => {
    // the sun keeps setting: it sinks below the sea, then comes down from the top again, faster and faster
    const u = cycSun(t), y = 0.6 - 0.9 * u, b = Math.pow(cycX(t), 1.5);
    const enter = smooth(0, 0.12, u), day = enter * (1 - smooth(0.6, 0.76, u));
    const glow = enter * smooth(-0.2, 0.05, y) * (1 - 0.5 * smooth(0.15, 0.5, y));
    return { z: mixArr([0.01, 0.01, 0.04], [0.08, 0.1, 0.26], day), h: mixArr([0.08, 0.05, 0.14], [1.0, 0.55, 0.38], glow), s: [0, y, -1], c: [1, 0.58, 0.34], i: (1.2 + 0.8 * b) * enter, st: 1 - day };
  };
  SKY[F.LETGO] = () => ({ z: [0.1, 0.12, 0.28], h: [0.95, 0.68, 0.5], s: [0.15, 0.05, -1], c: [1, 0.72, 0.5], i: 1.0, st: 0 });
  SKY[F.DESTINY] = () => ({ ...night, st: 1 });
  SKY[F.INK2] = SKY[F.INK];
  SKY[F.RAINUP] = t => { const k = smooth(193, 199.5, t); return { z: mixArr([0.025, 0.032, 0.06], [0.05, 0.06, 0.16], k), h: mixArr([0.12, 0.14, 0.21], [0.6, 0.48, 0.48], k), s: [0, 0.03, -1], c: [1, 0.8, 0.65], i: 0.6 * k, st: 0 }; };
  SKY[F.ONE] = t => {
    const late = smooth(208, 220, t);   // dusk falls as she is traced, so her light shows
    return { z: mixArr([0.06, 0.06, 0.16], [0.012, 0.012, 0.04], late), h: mixArr([0.8, 0.58, 0.55], [0.16, 0.09, 0.2], late), s: [0, -0.05, -1], c: [1, 0.8, 0.62], i: 0, st: late * 0.8 };
  };

  H.skyAt = function (form, t) {
    const s = SKY[form](t);
    return { z: s.z, h: s.h, s: s.s, c: s.c, i: s.i, st: s.st, storm: s.storm || 0, aur: s.aur || 0 };
  };
  H.mixSky = function (a, b, k) {
    const o = {};
    for (const key in a) o[key] = Array.isArray(a[key]) ? mixArr(a[key], b[key], k) : lerp(a[key], b[key], k);
    return o;
  };
  H.mixCam = function (a, b, k) {
    return { p: mixArr(a.p, b.p, k), q: mixArr(a.q, b.q, k), fov: lerp(a.fov, b.fov, k) };
  };
})();
